import { apiSlice, TAG_TYPES } from "../../features/api/apiSlice";

export const connectivityApi = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    // Renamed to avoid collision with getAllConnected in connectionApiSlice.js / userApiSlice.js
    getAllConnectedByUserId: builder.query({
      query: (params) => {
        if (params && typeof params === "object") {
          const { userId, isMarketerProfile } = params;
          // Always send the flag explicitly so /user-profile and
          // /marketing-profile never share one ambiguous cache/URL.
          const marketerFlag =
            isMarketerProfile === true || isMarketerProfile === "true"
              ? "true"
              : "false";
          return `/conection/getAllConnected/?userid=${userId}&isMarketerProfile=${marketerFlag}`;
        }
        return `/conection/getAllConnected/?userid=${params}&isMarketerProfile=false`;
      },
      // Separate cache entries for personal vs marketer Connectivity
      serializeQueryArgs: ({ queryArgs }) => {
        if (queryArgs && typeof queryArgs === "object") {
          const uid = queryArgs.userId || "";
          const marketer =
            queryArgs.isMarketerProfile === true ||
            queryArgs.isMarketerProfile === "true"
              ? "marketer"
              : "personal";
          return `getAllConnectedByUserId(${uid}|${marketer})`;
        }
        return `getAllConnectedByUserId(${queryArgs}|personal)`;
      },
      // Match connectionApiSlice invalidations ('UserConnections' / 'Connections')
      // so Connectivity boxes refresh right after accept/connect.
      providesTags: (result, error, arg) => {
        const uid = arg && typeof arg === "object" ? arg.userId : arg;
        const marketer =
          arg &&
          typeof arg === "object" &&
          (arg.isMarketerProfile === true || arg.isMarketerProfile === "true");
        return [
          "UserConnections",
          "Connections",
          { type: TAG_TYPES.CONNECTIONS, id: uid || "LIST" },
          { type: TAG_TYPES.CONNECTIONS, id: marketer ? `${uid}-marketer` : `${uid}-personal` },
          { type: TAG_TYPES.CONNECTIONS, id: "LIST" },
          { type: TAG_TYPES.USER_CONNECTIONS, id: uid || "LIST" },
          { type: TAG_TYPES.USER_CONNECTIONS, id: "LIST" },
        ];
      },
    }),

    getBusinessTypeRules: builder.query({
      query: (businessType) =>
        `/businesstyperules/rulebybusinesstype?businessType=${businessType}`,
      providesTags: () => [{ type: TAG_TYPES.CONNECTIONS, id: "LIST" }],
    }),

    shareToMessenger: builder.mutation({
      query: (data) => ({
        url: "/message/sharetomassenger",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetAllConnectedByUserIdQuery,
  useGetBusinessTypeRulesQuery,
  useShareToMessengerMutation,
} = connectivityApi;

export default connectivityApi;
